import * as React from 'react'
import { styleguide } from 'styleguide'

export default function({ className, color = 'primary' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 609 607"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g
        id="stripes-Desktop-Copy-4"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="square">
        <g
          id="stripes-Desktop-Home-Copy-9"
          transform="translate(-365.000000, -304.000000)"
          stroke={styleguide.colors[color]}
          stroke-width="2">
          <g id="stripes-Group-7" transform="translate(307.000000, 305.000000)">
            <g id="stripes-Group-4" transform="translate(57.000000, 0.000000)">
              <g
                id="stripes-Group-Copy"
                transform="translate(198.343452, 198.343452) rotate(45.000000) translate(-198.343452, -198.343452) translate(128.343452, -12.156548)">
                <path
                  d="M50.8181818,418.407314 L50.8181818,0.764482484"
                  id="stripes-Line-Copy-5"
                />
                <path
                  d="M38.3636364,418.407314 L38.3636364,0.764482484"
                  id="stripes-Line-Copy-6"
                />
                <path
                  d="M100.636364,418.407314 L100.636364,0.764482484"
                  id="stripes-Line-Copy-10"
                />
                <path
                  d="M25.9090909,418.407314 L25.9090909,0.764482484"
                  id="stripes-Line-Copy-7"
                />
                <path
                  d="M88.1818182,418.407314 L88.1818182,0.764482484"
                  id="stripes-Line-Copy-11"
                />
                <path
                  d="M113.090909,418.407314 L113.090909,0.764482484"
                  id="stripes-Line-Copy-14"
                />
                <path
                  d="M125.545455,418.407314 L125.545455,0.764482484"
                  id="stripes-Line-Copy-15"
                />
                <path
                  d="M138,418.407314 L138,0.764482484"
                  id="stripes-Line-Copy-16"
                />
                <path
                  d="M13.4545455,418.407314 L13.4545455,0.764482484"
                  id="stripes-Line-Copy-8"
                />
                <path
                  d="M75.7272727,418.407314 L75.7272727,0.764482484"
                  id="stripes-Line-Copy-12"
                />
                <path
                  d="M1,418.407314 L1,0.764482484"
                  id="stripes-Line-Copy-9"
                />
                <path
                  d="M63.2727273,418.407314 L63.2727273,0.764482484"
                  id="stripes-Line-Copy-13"
                />
              </g>
              <g
                id="stripes-Group-Copy-2"
                transform="translate(305.343452, 303.343452) rotate(45.000000) translate(-305.343452, -303.343452) translate(235.343452, 92.843452)">
                <path
                  d="M50.8181818,418.407314 L50.8181818,0.764482484"
                  id="stripes-Line-Copy-5"
                />
                <path
                  d="M38.3636364,418.407314 L38.3636364,0.764482484"
                  id="stripes-Line-Copy-6"
                />
                <path
                  d="M100.636364,418.407314 L100.636364,0.764482484"
                  id="stripes-Line-Copy-10"
                />
                <path
                  d="M25.9090909,418.407314 L25.9090909,0.764482484"
                  id="stripes-Line-Copy-7"
                />
                <path
                  d="M88.1818182,418.407314 L88.1818182,0.764482484"
                  id="stripes-Line-Copy-11"
                />
                <path
                  d="M113.090909,418.407314 L113.090909,0.764482484"
                  id="stripes-Line-Copy-14"
                />
                <path
                  d="M125.545455,418.407314 L125.545455,0.764482484"
                  id="stripes-Line-Copy-15"
                />
                <path
                  d="M138,418.407314 L138,0.764482484"
                  id="stripes-Line-Copy-16"
                />
                <path
                  d="M13.4545455,418.407314 L13.4545455,0.764482484"
                  id="stripes-Line-Copy-8"
                />
                <path
                  d="M75.7272727,418.407314 L75.7272727,0.764482484"
                  id="stripes-Line-Copy-12"
                />
                <path
                  d="M1,418.407314 L1,0.764482484"
                  id="stripes-Line-Copy-9"
                />
                <path
                  d="M63.2727273,418.407314 L63.2727273,0.764482484"
                  id="stripes-Line-Copy-13"
                />
              </g>
              <g
                id="stripes-Group-Copy-3"
                transform="translate(411.343452, 409.343452) rotate(45.000000) translate(-411.343452, -409.343452) translate(341.343452, 198.843452)">
                <path
                  d="M50.8181818,418.407314 L50.8181818,0.764482484"
                  id="stripes-Line-Copy-5"
                />
                <path
                  d="M38.3636364,418.407314 L38.3636364,0.764482484"
                  id="stripes-Line-Copy-6"
                />
                <path
                  d="M100.636364,418.407314 L100.636364,0.764482484"
                  id="stripes-Line-Copy-10"
                />
                <path
                  d="M25.9090909,418.407314 L25.9090909,0.764482484"
                  id="stripes-Line-Copy-7"
                />
                <path
                  d="M88.1818182,418.407314 L88.1818182,0.764482484"
                  id="stripes-Line-Copy-11"
                />
                <path
                  d="M113.090909,418.407314 L113.090909,0.764482484"
                  id="stripes-Line-Copy-14"
                />
                <path
                  d="M125.545455,418.407314 L125.545455,0.764482484"
                  id="stripes-Line-Copy-15"
                />
                <path
                  d="M138,418.407314 L138,0.764482484"
                  id="stripes-Line-Copy-16"
                />
                <path
                  d="M13.4545455,418.407314 L13.4545455,0.764482484"
                  id="stripes-Line-Copy-8"
                />
                <path
                  d="M75.7272727,418.407314 L75.7272727,0.764482484"
                  id="stripes-Line-Copy-12"
                />
                <path
                  d="M1,418.407314 L1,0.764482484"
                  id="stripes-Line-Copy-9"
                />
                <path
                  d="M63.2727273,418.407314 L63.2727273,0.764482484"
                  id="stripes-Line-Copy-13"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/Illustrations/Stripes.jsx